import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./LandingRiverInjector.module.scss";

const LandingRiverAd = ({ className, ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, className)}
      format="injector"
      targetingNative="standard,background,video,gift"
      sizesAt0="native,mobile-wide"
      sizesAt1010="native"
      {...props}
    />
  );
};

export default LandingRiverAd;
